import React from 'react'
import Header from './components/Header';
import Footer from './components/Footer';
import { useState,useEffect } from 'react';
import './styles/motoStyles.css';
import lotus from '../src/images/lotus.png';

const LandRevenue = () => {
  const [fadeOut, setFadeOut] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

    
    useEffect(() => {
      const handleScroll = () => {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        if (scrollTop > 50) {
          setScrolled(true);
        } else {
          setScrolled(false);
        }
      };
    
      window.addEventListener("scroll", handleScroll);
      handleScroll();
    
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);
  return (
    <div>
      <div className={`moto ${fadeOut ? 'fade-out' : ''}`}>
        <h1>Revenue & Land Disputes here at KWA</h1>
      </div>
      <Header scrolled={scrolled}/>
      <div className='justify-content-center d-flex align-items-center w-100 fs-4' style={{minHeight:'100vh',padding:'10%',paddingTop: '5%',paddingBottom: '5%'}}>
        <img src={lotus} alt='' className='lotus'></img>
        <div className=''><p>Welcome to <span className="kwa">KWA</span>, where we specialize in navigating the complexities of <span className="highlight">Indian land laws</span>, offering unparalleled expertise in resolving <span className="highlight">revenue and land disputes</span>, along with a comprehensive suite of services addressing diverse land matters.</p>
        <br />
        <p>Our seasoned legal team is proficient in handling a spectrum of land-related issues, ranging from property ownership disputes to encumbrance matters. With a deep understanding of the intricate legal frameworks governing land transactions and revenue matters in India, we provide strategic counsel and advocacy tailored to each client's unique circumstances.</p>
        <br />
        <p>In <span className="highlight">revenue and land disputes</span>, our firm excels in conducting thorough investigations, analysing pertinent documentation, and crafting effective legal strategies aimed at achieving favourable outcomes. We represent clients across various forums, including civil courts, revenue courts, and administrative tribunals, adeptly navigating procedural nuances and advocating vigorously for their interests.</p>
        <br />
        <p>Furthermore, our expertise extends to addressing other land matters such as title disputes, land acquisition, zoning regulations, and land use planning. We offer proactive guidance to individuals, businesses, and governmental entities, helping them navigate the intricacies of land laws and regulations to safeguard their rights and interests.</p>
        <br />
        <p>At <span className="kwa">KWA</span>, our commitment to excellence, coupled with our deep-rooted knowledge of Indian land laws, ensures that our clients receive the highest caliber of legal representation in all matters pertaining to <span className="highlight">revenue</span>, <span className="highlight">land</span>, and <span className="highlight">property disputes</span>. Trust us to be your steadfast legal partners in navigating the complexities of Indian land laws with precision and diligence.</p></div>
      </div>
      <Footer />
    </div>
  )
}

export default LandRevenue
